import getPageName from "../modules/getPageName";

/* Логика для страниц каталога фильтрации программ */
const catalog = () => {
  const notFound = document.querySelector(".catalog__notFound");

  if (getPageName() === "employed-job-seeker") {
    document
      .querySelectorAll(".tile__head-block__cost")
      .forEach(
        (field) => (field.innerHTML = "Подходит для трудоустроенных")
      );
  }

  /*  В каталоге при клике на карточку переход на программу */
  $(document).on("click", ".tile", function () {
    window.location = $(this).find("a").attr("href");
  });

  if (!notFound) {
    return;
  }

  /* Замена свойства overflow для основного wrapper, чтобы сработало position: sticky для меню фильтров */
  document.querySelector(".wrapper").style.overflow = "visible";

  const utmCategory = getParam("category"),
    utmLevel = getParam("level"),
    utmFormat = getParam("format"),
    inputsCategory = document.querySelectorAll('input[name="category"]'),
    inputsLevel = document.querySelectorAll('input[name="level"]'),
    inputsFormat = document.querySelectorAll('input[name="format"]'),
    linksPrograms = document.querySelectorAll(".tile__open-btn"),
    linksDirections = document.querySelectorAll(".catalog-filter"),
    wrap = document.querySelector(".catalog__courses");

  /* Список программ доступных для категории ищущих */
  const list = [
    'onec144',
    'accountant',
    'personneladmin',
    'methodist',
    'bpla',
    'preschool-education',
    'social-worker',
    'social-specialist',
    'softwaretesting',
    'webprogrammer',
    'repair-locksmith',
    'car-locksmith'
  ];

  const offlinePrograms = [
    'cook',
    'medical-care',
    'repair-master',
    'foreman',
    'bim-engineering',
    'car-locksmith',
    'repair-locksmith',
    'welding',
    'electric-welder'
  ];

  /* Инициализация */
  (() => {
    // Добавление активности для инпута на основе данных из utm метки
    if (utmCategory) {
      inputsCategory.forEach((input) => {
        if (input.value == utmCategory) {
          input.setAttribute("checked", "true");
        }
      });
    }

    if (utmLevel) {
      inputsLevel.forEach((input) => {
        if (input.value == utmLevel) {
          input.setAttribute("checked", "true");
        }
      });
    }

    if (utmFormat) {
      inputsFormat.forEach((input) => {
        if (input.value == utmFormat) {
          input.setAttribute("checked", "true");
        }
      });
    }

    update();
    initFiltersPopup();
    resetAllFilters();

    /* Замена текста в плашках для программ категории ищущих */
    linksPrograms.forEach((tile) => {
      if (list.includes(returnPageProgram(tile.href))) {
        let field = tile
          .closest(".tile")
          .querySelector(".tile__head-block__cost");
        field.innerHTML = "Подходит для&nbsp;ищущих работу";
      }
    });
    
    /* Замена текста в плашках для офлайн программ */
    linksPrograms.forEach((tile) => {
      if (offlinePrograms.includes(returnPageProgram(tile.href))) {
        let field = tile
          .closest(".tile")
          .querySelector(".tile__head-block__cost");
        field.innerHTML = "Офлайн";
      }
    });
  })();

  /* Функция добавления UTM меток в url сайта */
  const updateQueryStringParam = function (key, value) {
    let url = new URL(document.location.href);

    url.searchParams.set(key, value);
    window.history.replaceState({}, "", url.href);
  };

  /* Событие на чекбокс категории */
  inputsCategory.forEach((input) => {
    input.addEventListener("change", () => {
      updateQueryStringParam("category", input.value);
      update();
      scrollToTop();
    });
  });

  /* Событие на чекбокс уровня образования */
  inputsLevel.forEach((input) => {
    input.addEventListener("change", () => {
      updateQueryStringParam("level", input.value);
      update();
      scrollToTop();
    });
  });

  /* Событие на чекбокс формата обучения */
  inputsFormat.forEach((input) => {
    input.addEventListener("change", () => {
      updateQueryStringParam("format", input.value);
      update();
      scrollToTop();
    });
  });
  
  /* Функция для попапа фильтров */
  function initFiltersPopup () {
    const filtersContainer = document.querySelector(".catalog__filters-radios");
    if (!filtersContainer) return;

    const filtersPopupButton = document.querySelector(".catalog__filters-button");
    const filtersPopupClose = filtersContainer.querySelector(".catalog__filters-close");

    filtersPopupButton.addEventListener("click", () => {
      filtersContainer.classList.add("is-active");
      document.body.classList.add("scroll-lock");

      filtersPopupClose.addEventListener("click", () => {
        filtersContainer.classList.remove("is-active");
        document.body.classList.remove("scroll-lock");
      })
    })
  };

  /* Обновление контента */
  function update() {
    filterProgramsByFormat(searchValueCheckbox(inputsFormat));
    filterProgramsByCategory(searchValueCheckbox(inputsCategory));
    blockDisplayLogic(searchValueCheckbox(inputsLevel));
    addLinks();
  }

  /* Отображение или скрытие блока списка программ и notFound */
  function blockDisplayLogic(level) {
    let countDPO = countPrograms(".catalog__DPO"),
      countPO = countPrograms(".catalog__PO"),
      DPO = document.querySelector(".catalog__DPO"),
      PO = document.querySelector(".catalog__PO");

    if (level == "DPO") {
      DPO.style.display = "block";
      if (PO) {
        PO.style.display = "none";
      }

      if (countDPO < 1) {
        wrap.style.display = "none";
        notFound.style.display = "flex";
      } else {
        wrap.style.display = "flex";
        notFound.style.display = "none";
      }
    } else if (level == "PO") {
      DPO.style.display = "none";
      if (PO) {
        PO.style.display = "block";
      }

      if (countPO < 1) {
        wrap.style.display = "none";
        notFound.style.display = "flex";
      } else {
        wrap.style.display = "flex";
        notFound.style.display = "none";
      }
    } else {
      if (countDPO < 1 && countPO < 1) {
        wrap.style.display = "none";
        notFound.style.display = "flex";
      } else if (countDPO < 1) {
        DPO.style.display = "none";
        wrap.style.display = "flex";
        notFound.style.display = "none";
      } else {
        DPO.style.display = "block";
        wrap.style.display = "flex";
        notFound.style.display = "none";
      }
    }
  }

  /* Фильтрация программ */
  function filterProgramsByCategory(filter) {
    if (filter == "employed") {
      let count = 0;

      linksPrograms.forEach((tile) => {
        if (list.includes(returnPageProgram(tile.href)) && !tile.closest(".tile").classList.contains("hidden")) {
          if (count == 4) {
            count = 0;
          }

          count++;
          changeStateTiles(tile, count);
        } else {
          hiddenTiles(tile);
        }
      });
    } else if (filter == "all") {
      let count = 0;

      linksPrograms.forEach((tile) => {
        if (!tile.closest(".tile").classList.contains("hidden")) {
          if (count == 4) {
            count = 0;
          }
  
          count++;
          changeStateTiles(tile, count)
          
        }
      });
    }
  }

  /* Фильтрация программ по формату */
  function filterProgramsByFormat(filter) {
    if (filter == "offline") {
      let count = 0;

      linksPrograms.forEach((tile) => {
        if (offlinePrograms.includes(returnPageProgram(tile.href))) {
          if (count == 4) {
            count = 0;
          }

          count++;
          changeStateTiles(tile, count);
        } else {
          hiddenTiles(tile);
        }
      });
    } else if (filter == "online") {
      let count = 0;

      linksPrograms.forEach((tile) => {
        if (!offlinePrograms.includes(returnPageProgram(tile.href))) {
          if (count == 4) {
            count = 0;
          }

          count++;
          changeStateTiles(tile, count);
        } else {
          hiddenTiles(tile);
        }
      });
    } else {
      let count = 0;

      linksPrograms.forEach((tile) => {
        if (count == 4) {
          count = 0;
        }

        count++;
        changeStateTiles(tile, count);
      });
    }
  }

  /* Отобраение и замена цвета у карточек каталога */
  function changeStateTiles(tile, count) {
    const colors = [
      ["#703EFF", "#9373F1"],
      ["#3E74FF", "#7599F6"],
      ["#DB803E", "#F1A771"],
      ["#B63EFF", "#C365FD"],
    ];

    if (tile.closest(".tile").classList.contains("hidden")) {
      tile.closest(".tile").classList.remove("hidden");
    }

    tile.closest(".tile").style.backgroundColor = colors[count - 1][0];
    tile.closest(".tile").querySelector(".tile__oval").style.backgroundColor =
      colors[count - 1][1];

    tile.closest(".tile").style.display = "flex";
    tile.closest(".tile").classList.add("visible");
  }

  /* Скрытие карточки в каталоге */
  function hiddenTiles(tile) {
    if (tile.closest(".tile").classList.contains("visible")) {
      tile.closest(".tile").classList.remove("visible");
    }

    tile.closest(".tile").classList.add("hidden");
    tile.closest(".tile").style.display = "none";
  }

  /* Скрытие или отображение блока для программ ДПО и ПО */
  function countPrograms(block) {
    const wrap = document.querySelector(block);

    if (!wrap) {
      return 0;
    }

    const programs = wrap.querySelectorAll(".tile.visible");
    return programs.length;
  }

  /* Добавление для ссылок на направлениях utm меток */
  function addLinks() {
    let category = searchValueCheckbox(inputsCategory),
      level = searchValueCheckbox(inputsLevel),
      format = searchValueCheckbox(inputsFormat);

      if (category && !level && !format) {
        linksDirections.forEach((link) => {
          let href = link.href;
          link.href = href.split("?")[0] + `?category=${category}`;
        });
      } else if (category && level && !format) {
        linksDirections.forEach((link) => {
          let href = link.href;
          link.href = href.split("?")[0] + `?category=${category}&level=${level}`;
        });
      } else if (category && level && format) {
        linksDirections.forEach((link) => {
          let href = link.href;
          link.href = href.split("?")[0] + `?category=${category}&level=${level}&format=${format}`;
        });
      } else if (!category && level && !format) {
        linksDirections.forEach((link) => {
          let href = link.href;
          link.href = href.split("?")[0] + `?level=${level}`;
        });
      } else if (!category && !level && format) {
        linksDirections.forEach((link) => {
          let href = link.href;
          link.href = href.split("?")[0] + `?format=${format}`;
        });
      } else if (!category && level && format) {
        linksDirections.forEach((link) => {
          let href = link.href;
          link.href = href.split("?")[0] + `?level=${level}&format=${format}`;
        });
      } else {
        linksDirections.forEach((link) => {
          let href = link.href;
          link.href = href.split("?")[0];
        });
      }
  }

  /* Поиск выбранного чекбокса */
  function searchValueCheckbox(inputs) {
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) {
        let value = inputs[i].value;

        return value;
      }
    }
  }

  /* Получение url программы из ссылки */
  function returnPageProgram(link) {
    const segments = link.split("/"),
      last = segments.pop() || segments.pop();

    return last;
  }

  /* Функция получения определенной utm метки */
  function getParam(param) {
    const urlParams = new URL(window.location.toString()).searchParams;
    return urlParams.get(param) || "";
  }

  /* Сброс установок фильтров */
  function resetAllFilters() {
    let resetAllFilters = document.querySelector('.catalog__filters-li-button');

    resetAllFilters.addEventListener('click', () => {
      document.location.href = '/catalog';
    });
  }

  /* Плавный скролл в начало блока списка программ */
  function scrollToTop() {
    let scropllBlock = document.querySelector(".catalog__wrap");
    if (scropllBlock) {
      scropllBlock.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
};

export default catalog;
